import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'address' })
export class PipeAddress implements PipeTransform {

    transform(value: string | undefined): string {
        if (value) {
            return value.slice(0, 5) + '..' + value.slice(-3);
        } else {
            return ''
        }
    }
}